import _findKey from 'lodash.findkey';
import { CURRENCY_MARKUP, CURRENCY_CONVERSION } from '../constants/currency';









export default function convertCurrency({
  fromCurrency,
  toCurrency = '',
  value,
  addMarkup = true,
  toBaseCurrency = false
}) {
  const baseCurrency = _findKey(CURRENCY_CONVERSION, (currency) => currency === 1); // always returns "USD"

  if (toBaseCurrency) {
    const originalValue = addMarkup ?
    value / CURRENCY_CONVERSION[fromCurrency] / CURRENCY_MARKUP[fromCurrency] :
    value / CURRENCY_CONVERSION[fromCurrency];

    return Math.round(originalValue);
  }

  let newValue = value * CURRENCY_CONVERSION[toCurrency];

  if (fromCurrency !== baseCurrency && toCurrency === baseCurrency) {
    newValue = value / CURRENCY_CONVERSION[fromCurrency];
  }

  if (fromCurrency !== baseCurrency && toCurrency !== baseCurrency) {
    newValue = value / CURRENCY_CONVERSION[fromCurrency] * CURRENCY_CONVERSION[toCurrency];
  }

  return Math.round(addMarkup ? newValue * CURRENCY_MARKUP[toCurrency] : newValue);
}